import React, { useState } from "react";
import axios from "axios";
import { Card, Typography, Input, Button, Select, message } from "antd";
import LinkIcon from "@mui/icons-material/Link";
import MailIcon from "@mui/icons-material/Mail";
import styled from "@emotion/styled";
import InviteModal from "../Modals/Dashboard/EmailInviteModal";
import { URL } from "../../helper/Mainurl";

const { Title } = Typography;
const { Option } = Select;

const InviteCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  .ant-card-head {
    border-bottom: none;
    padding: 16px 24px;
  }
  .ant-card-body {
    padding: 0 24px 24px;
  }

  @media (max-width: 768px) {
    .ant-card-head {
      padding: 12px 16px;
    }
    .ant-card-body {
      padding: 0 16px 16px;
    }
  }
`;

const EmailInputContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

const EmailInput = styled(Input)`
  border-radius: 8px;
  flex: 1;
  min-width: 220px;
`;

const InviteButton = styled(Button)`
  width: 100%;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
`;

const SelectionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const SelectLabel = styled.div`
  font-weight: 500;
  margin-bottom: 8px;
  color: #4b5563;
`;

const StyledSelect = styled(Select)`
  width: 100%;
  .ant-select-selector {
    border-radius: 8px !important;
  }
`;

const InviteSection = ({ inviteOpen, setInviteOpen }) => {
  const [email, setEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("family");
  const [selectedAccess, setSelectedAccess] = useState("view"); // Null by default

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const getPermissionId = (access) => {
    const map = {
      full: 3,
      view: 4,
      limited: 5,
      edit: 6
    };
    return map[access] || 4; // Default to 'view' if not selected
  };

  const handleInvite = async () => {
    const permissionId = getPermissionId(selectedAccess);

    const payload = {
      invitations: [
        {
          email: email,
          feature: "member",
          // permission_id: permissionId,
          // children: [
          //   { name: "Rasika" },
          //   { name: "Tuppii" }
          // ]
        }
      ]
    };

    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${URL}/v1/invite/send`,
        payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );
      message.success("Invitation sent successfully!");
      setEmail("");
    } catch (error) {
      console.error("Invitation error:", error);
      message.error(error.response.data.message || "Failed to send invitation.");
    }
  };

  return (
    <InviteCard
      title={
        <Title level={4} style={{ margin: 0 }}>
          Invite Someone
        </Title>
      }
    >
      <EmailInputContainer>
        <EmailInput
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          type="primary"
          icon={<MailIcon style={{ fontSize: 20 }} />}
          onClick={handleInvite}
          disabled={!isValidEmail(email)}
          style={{
            padding: "19px 10px",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}
        >
          Invite
        </Button>
      </EmailInputContainer>

      <InviteButton
        type="primary"
        icon={<LinkIcon style={{ fontSize: 20 }} />}
        onClick={() => setInviteOpen(true)}
      >
        Invite with link
      </InviteButton>

      <SelectionContainer>
        {/* <div>
          <SelectLabel>Role</SelectLabel>
          <StyledSelect
            defaultValue="family"
            onChange={(value) => setSelectedRole(value)}
          >
            <Option value="family">Family Member</Option>
            <Option value="friend">Friend</Option>
            <Option value="coworker">Coworker</Option>
            <Option value="admin">Admin</Option>
          </StyledSelect>
        </div> */}

        {/* <div>
          <SelectLabel>Access</SelectLabel>
          <StyledSelect
            defaultValue="view"
            placeholder="Select Access"
            onChange={(value) => setSelectedAccess(value)}
            allowClear
          >
            <Option value="limited">Limited</Option>
            <Option value="view">View Only</Option>
            <Option value="edit">Edit</Option>
            <Option value="full">Full Access</Option>
          </StyledSelect>
        </div> */}
      </SelectionContainer>
      <InviteModal open={inviteOpen} onClose={() => setInviteOpen(false)} />
    </InviteCard>
  );
};

export default InviteSection;
